export default "__VITE_ASSET__CBPdHmMD__"